export const userQuery = (userId) => {
    const query =`*[_type == "user" && _id == '${userId}']`;

    return query;
}

export const searchCodeTableQuery = (category) => {
  const query =`*[_type == "codeTable" && category == '${category}'] | order(name asc)`;

  return query;
}

export const searchQuery = (searchTerm) => {
const query = `*[_type == "prompt" && title match '${searchTerm}*' || category match '${searchTerm}*' || instruction match '${searchTerm}*'  && status match 'Approved']{
    image {
        asset -> {
            url
        }
    },
    _id,
    type,
    status,
    postedBy -> {
        _id,
        userName,
        image
    },
    favourite[] {
        _key,
        postedBy -> {
            _id,
            userName,
            image
        },
    },
}`

return query;
};


export const searchByAIGenIdQuery = (aiGenId) => {
  const query = `*[_type == "prompt" && type match '${aiGenId}*'  && status match 'Approved']{
      image {
          asset -> {
              url
          }
      },
      _id,
      type,
      status,
      postedBy -> {
          _id,
          userName,
          image
      },
      favourite[] {
          _key,
          postedBy -> {
              _id,
              userName,
              image
          },
      },
  }`
  
  return query;
  };

  export const searchByCategoryQuery = (categoryId) => {
    const query = `*[_type == "prompt" && category match '${categoryId}*'  && status match 'Approved']{
        image {
            asset -> {
                url
            }
        },
        _id,
        type,
        status,
        postedBy -> {
            _id,
            userName,
            image
        },
        favourite[] {
            _key,
            postedBy -> {
                _id,
                userName,
                image
            },
        },
    }`
    
    return query;
    };

export const feedQuery = `*[_type == 'prompt' && status match 'Approved'] | order(_createdAt desc) {
    image {
        asset -> {
            url
        }
    },
    _id,
    type,
    status,
    postedBy -> {
        _id,
        userName,
        image
    },
    favourite[] {
        _key,
        postedBy -> {
            _id,
            userName,
            image
        },
    },
}`;

export const searchByCategoryAndSortQuery = (categoryId, sort) => {
  const query = `*[_type == "prompt" && category match '${categoryId}*'  && status match 'Approved'] | order(_createdAt ${sort}) {
      image {
          asset -> {
              url
          }
      },
      _id,
      type,
      status,
      postedBy -> {
          _id,
          userName,
          image
      },
      favourite[] {
          _key,
          postedBy -> {
              _id,
              userName,
              image
          },
      },
  }`
  
  return query;
  };

  export const searchByCategoryAndFilterAndSortQuery = (categoryId, filter, sort) => {
    const query = `*[_type == "prompt" && category match '${categoryId}*'  && status match 'Approved' && type match '${filter}*'] | order(_createdAt ${sort}) {
        image {
            asset -> {
                url
            }
        },
        _id,
        type,
        status,
        postedBy -> {
            _id,
            userName,
            image
        },
        favourite[] {
            _key,
            postedBy -> {
                _id,
                userName,
                image
            },
        },
    }`
    
    return query;
    };

export const feedBySortQuery = (sort) => {
  const query = `*[_type == 'prompt' && status match 'Approved'] | order(_createdAt ${sort}){
      image {
          asset -> {
              url
          }
      },
      _id,
      type,
      status,
      postedBy -> {
          _id,
          userName,
          image
      },
      favourite[] {
          _key,
          postedBy -> {
              _id,
              userName,
              image
          },
      },
  }`
  
  return query;
  };

  export const feedByFilterAndSortQuery = (filter, sort) => {
    const query = `*[_type == 'prompt' && status match 'Approved' && type match '${filter}*'] | order(_createdAt ${sort}){
        image {
            asset -> {
                url
            }
        },
        _id,
        type,
        status,
        postedBy -> {
            _id,
            userName,
            image
        },
        favourite[] {
            _key,
            postedBy -> {
                _id,
                userName,
                image
            },
        },
    }`
    
    return query;
    };

// export const categories = [
//     {
//       name: 'Abstract'
//     },
//     {
//       name: 'Animals'
//     },
//     {
//       name: 'Architecture'
//     },
//     {
//       name: 'Environment'
//     },
//     {
//       name: 'Experimental'
//     },
//     {
//       name: 'Logos & Icons'
//     },
//     {
//       name: 'Nature'
//     },
//     {
//       name: 'Objects'
//     },
//     {
//       name: 'People'
//     }, 
//     {
//       name: 'Textures & Patterns'
//     }
//   ];

//   export const AIGenType = [
//     {
//       name: 'Midjourney'
//     },
//     {
//       name: 'DALL-E'
//     },
//     {
//       name: 'Stable Diffusion'
//     }
//   ];

  export const promptDetailQuery = (promptId) => {
    const query = `*[_type == "prompt" && _id == '${promptId}' && status match 'Approved']{
      image{
        asset->{
          url
        }
      },
      _id,
      title,
      type,
      line, 
      category,
      instruction,
      status,
      postedBy->{
        _id,
        userName,
        image
      },
      favourite[]{
        _key,
        postedBy->{
          _id,
          userName,
          image
        },
      }
    }`;
    return query;
  };
  
  export const promptDetailMorePromptQuery = (prompt) => {
    const query = `*[_type == "prompt" && category == '${prompt.category}' && _id != '${prompt._id}' && status match 'Approved']{
      image{
        asset->{
          url
        }
      },
      _id,
      type,
      status,
      postedBy->{
        _id,
        userName,
        image
      },
      favourite[]{
        _key,
        postedBy->{
          _id,
          userName,
          image
        },
      },
    }`;
    return query;
  };

  export const userCreatedPromptsQuery = (userId) => {
    const query = `*[ _type == 'prompt' && userId == '${userId}'] | order(_createdAt desc){
      image{
        asset->{
          url
        }
      },
      _id,
      type,
      status,
      postedBy->{
        _id,
        userName,
        image
      },
      favourite[]{
        postedBy->{
          _id,
          userName,
          image
        },
      },
    }`;
    return query;
  };
  
  export const userSavedPromptsQuery = (userId) => {
    const query = `*[_type == 'prompt' && '${userId}' in favourite[].userId && status match 'Approved'] | order(_createdAt desc) {
      image{
        asset->{
          url
        }
      },
      _id,
      type,
      status,
      postedBy->{
        _id,
        userName,
        image
      },
      favourite[]{
        postedBy->{
          _id,
          userName,
          image
        },
      },
    }`;
    return query;
  };